module.exports = __webpack_public_path__ + "img/1698372899798-halal rudiyono.jpg.c8a07dcb.webp";